// @mui
import { List, Stack } from '@mui/material';
// locales
import { useLocales } from '../../../locales';
//
import { NavSectionProps } from '../types';
import { StyledSubheader } from './styles';
import NavList from './NavList';
import { useGetAuthUser } from '../../../hooks/useGetAuthUser';

// ----------------------------------------------------------------------

export default function NavSectionVertical({ data, sx, ...other }: NavSectionProps) {
  const { translate } = useLocales();

  // get current auth user

  const { user } = useGetAuthUser()

  return (
    <Stack sx={sx} {...other}>
      {data.map((group) => {
        const key = group.subheader || group.items[0].title;

        // TODO: Following roles verification are just for testing purposes, they must be handled in more prof way,
        //----------
        if (
          (user?.role !== 'MANAGER' && user?.role !== 'STAFF' && user?.role !== 'SUPER_ADMIN')
          &&
          group.subheader === 'management'
        ) {
          return null
        }

        //----------

        return (
          <List key={key} disablePadding sx={{ px: 2 }}>
            {group.subheader && (
              <StyledSubheader disableSticky>{`${translate(group.subheader)}`}</StyledSubheader>
            )}

            {group.items.map((list) => {
              // Hide links with undefined or null IDs in path to prevent 404s
              if (list.path.includes('undefined') || list.path.includes('null')) {
                return null;
              }

              //----------
              // Hide "Sub-organizations" and "Branch Organization" for SUPER_ADMIN
              // Using path check as titles are translated and brittle
              if (
                user?.role === 'SUPER_ADMIN' &&
                (list.path.includes('/branches') ||
                  (list.path.includes('/sub-organization') && list.path !== '/dashboard/sub-organization/list'))
              ) {
                return null;
              }

              if (
                user?.role === 'MANAGER' &&
                (list.path.includes('/organization/list'))
              ) {
                return null;
              }

              if (
                user?.role === 'STAFF' &&
                (list.path.includes('/organization/list') || list.path.includes('/branches'))
              ) {
                return null;
              }
              //----------

              return (
                <NavList
                  key={list.key || list.title + list.path}
                  data={list}
                  depth={1}
                  hasChild={!!list.children}
                />
              );
            })}
          </List>
        );
      })}
    </Stack>
  );
}
